import type { ReactNode } from "react";
import Box from "@mui/material/Box";
import type { SxProps, Theme } from "@mui/material/styles";

interface ListGridTemplateProps {
  areas: string;
  columns: string;
  children: ReactNode;
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

export const LIST_GRID_EXPANDED_INSET = "32px";

/**
 * The grid a ListGrid's rows and headings are laid out on: pass the same `areas` and `columns` to
 * every row and the headings; cells place themselves by gridArea name. Give the stretchy column a
 * minimum (minmax(200px, 1fr)) so a narrow list scrolls sideways rather than squeezing.
 */
export const ListGridTemplate = (props: ListGridTemplateProps) => {
  const { areas, columns, children, onClick, sx } = props;

  return (
    <Box
      onClick={onClick}
      sx={[
        {
          alignItems: "center",
          display: "grid",
          gridTemplateAreas: areas,
          gridTemplateColumns: columns,
          pl: 2.5,
          pr: 1,
          "& > *": { minWidth: 0 },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Box>
  );
};
